import Event from '../../core/Event';
import StockError from '../../../domain/orders/validators/error';

export default class OrderValidated extends Event {
    public static type = 'OrderValidated';

    constructor(public readonly error: StockError) {
        super(OrderValidated.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderValidated.ts